/* Qvicio PRO — scripts propios */
(function () {
  function initReveal() {
    var els = document.querySelectorAll('.qv-reveal:not(.qv-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('qv-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('qv-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initEdad() {
    var modal = document.querySelector('[data-qv-edad]');
    if (!modal) return;
    var clave = 'qv-mayor-edad';
    var dias = parseInt(modal.getAttribute('data-dias') || '30', 10);
    var enEditor = document.documentElement.classList.contains('shopify-design-mode');
    var guardado = null;
    try { guardado = localStorage.getItem(clave); } catch (e) {}
    var vigente = guardado && (Date.now() - parseInt(guardado, 10)) < dias * 864e5;
    if (vigente || (enEditor && modal.getAttribute('data-editor') !== 'true')) return;

    modal.classList.add('qv-edad--abierta');
    document.documentElement.classList.add('qv-bloqueo');
    var si = modal.querySelector('[data-qv-si]');
    if (si) si.focus();
    modal.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-qv-si],[data-qv-no]');
      if (!t) return;
      if (t.hasAttribute('data-qv-si')) {
        try { localStorage.setItem(clave, String(Date.now())); } catch (e) {}
        modal.classList.remove('qv-edad--abierta');
        document.documentElement.classList.remove('qv-bloqueo');
      } else {
        window.location.href = t.getAttribute('data-url') || 'https://www.google.es';
      }
    });
  }

  function init() { initReveal(); initEdad(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', initReveal);
})();
